import { render, staticRenderFns } from "./PhotoAdd.vue?vue&type=template&id=63bdaed9&scoped=true"
import script from "./PhotoAdd.vue?vue&type=script&lang=js"
export * from "./PhotoAdd.vue?vue&type=script&lang=js"
import style0 from "./PhotoAdd.vue?vue&type=style&index=0&id=63bdaed9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bdaed9",
  null
  
)

export default component.exports